import React from 'react';
import CompanyDetailsCard from './CompanyDetailsCard';
import UploadDocumentsCard from './UploadDocumentsCard';
import TraderList from './TraderList';
import BuyOrSell from './BuyOrSell';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import AddTraderList from './AddTraderList';
import { checkPermission } from '../../../../redux/features/authSlice';

export default function CompanyProfileSetting({ onClickEdit }) {
  const { companyDetails, user } = useSelector((state) => state.auth);
  const settingPermission = useSelector((state) => checkPermission(state, 'Settings', 'Manage Company Profile'));

  const [showTraderRequest, setShowTraderRequest] = useState(false);
  return (
    <div>
      <CompanyDetailsCard onClickEdit={() => onClickEdit()} />

      <Stack sx={{ height: '12px' }} />
      {user?.type !== 'trader' && settingPermission.addAccess && <BuyOrSell />}
      <Stack sx={{ height: '12px' }} />
      {settingPermission.addAccess && user?.type !== 'trader' && <UploadDocumentsCard />}   
      {user?.type !== 'trader' && (
        <>

          <Stack sx={{ height: '12px' }} />
          {!showTraderRequest && <TraderList showTraderRequest={() => {
            setShowTraderRequest(true);
          }} />}
          {showTraderRequest && <AddTraderList handleClose={() => {
            setShowTraderRequest(false);
          }} />}
        </>
      )}
    </div>
  );
}
